module.exports = __webpack_public_path__ + "static/media/crazy-beef-sichuan-ncropped.c3815180.png";